"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
function SectionCard({ children, className, testId, }) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('bg-surface-dark', 'border border-borderColor', 'p-8', className), "data-testid": testId }, children));
}
exports.SectionCard = SectionCard;
//# sourceMappingURL=SectionCard.js.map